import React from 'react';
import { useTranslations } from '@lang';
import { MetadataRow, QuantityText, ProductQuantityPicker } from './ProductMetadata.styles';

export const ProductMetadata = ({
  isQuantityPickerHidden,
  quantity,
  option,
  onQuantityChange,
  isEditable,
}) => {
  const { t } = useTranslations();

  return (
    <div>
      {option && <MetadataRow>{option.name}</MetadataRow>}
      {!isQuantityPickerHidden && isEditable && (
        <MetadataRow>
          <ProductQuantityPicker
            input={{
              value: quantity,
              onChange: onQuantityChange,
            }}
          />
        </MetadataRow>
      )}
      {!isQuantityPickerHidden && !isEditable && quantity && (
        <MetadataRow>
          <QuantityText>{t('basket.quantityShortcut', { quantity })}</QuantityText>
        </MetadataRow>
      )}
    </div>
  );
};
